import React from 'react';
import { Paper, Typography } from '@mui/material';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PeopleIcon from '@mui/icons-material/People';
import { useTranslation } from 'react-i18next';
import StatCard from '../StatCard';
import StatCardsRow from '../StatCardsRow';
import EarningsBarChartWeekly from '../Charts/EarningsBarChartWeekly';
import { getWeeksOfYear } from '../../../utils/dateRange';
import { statPaper, statTitle, statYearNote } from '../../../styles/CalculateMoney/OverviewCommonStyles';

export default function OverviewWeekView({ data, week, year }) {
  const { t } = useTranslation('overview');
  const dailyDetails = data?.dailyDetails?.$values || data?.dailyDetails || [];

  const weekList = getWeeksOfYear(year);
  const weekInfo = weekList[week - 1] || { start: "?", end: "?" };
  const { start, end } = weekInfo;

  const totalEarnings = dailyDetails.reduce((sum, d) => sum + (d.totalEarnings || 0), 0);
  const totalSessions = dailyDetails.reduce((sum, d) => sum + (d.sessionCount || 0), 0);

  return (
    <>
      <StatCardsRow>
        <StatCard
          icon={<MonetizationOnIcon fontSize="large" />}
          label={t('stats.totalEarnings')}
          value={`${totalEarnings} €`}
          color="primary"
        />
        <StatCard
          icon={<PeopleIcon fontSize="large" />}
          label={t('stats.totalSessions')}
          value={totalSessions}
          color="success"
        />
      </StatCardsRow>
      <Paper elevation={0} sx={statPaper}>
        <Typography variant="subtitle1" sx={statTitle}>
          {t('week.label', { week })}{' '}
          <span style={statYearNote}>({t('week.range', { start, end })})</span>
        </Typography>
        <EarningsBarChartWeekly dailyDetails={dailyDetails} />
      </Paper>
    </>
  );
}